import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class RouteManagerService {
    private readonly LAST_ROUTE_KEY = 'lastValidRoute';
    private readonly EXCLUDED_ROUTES = ['/login', '/', '/notpermited'];

    constructor(private router: Router) {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.saveRouteIfValid(event.url);
            });
    }

    private saveRouteIfValid(route: string): void {
        if (!this.EXCLUDED_ROUTES.includes(route) && !route.includes('?')) {
            localStorage.setItem(this.LAST_ROUTE_KEY, route);
        }
    }

    getLastValidRoute(): string | null {
        return localStorage.getItem(this.LAST_ROUTE_KEY);
    }

    clearLastValidRoute(): void {
        localStorage.removeItem(this.LAST_ROUTE_KEY);
    }

    isValidRoute(route: string): boolean {
        return !this.EXCLUDED_ROUTES.includes(route) && route !== '';
    }

    updateRouteWithCnpj(route: string, newCnpj: string): string {
        const routeParts = route.split('/');
        if (routeParts.length >= 3) {
            routeParts[2] = newCnpj;
            return routeParts.join('/');
        }
        return route;
    }
}
